import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import HttpBackend, { type HttpBackendOptions } from 'i18next-http-backend';

export const applyGlobalConfigI18next = () =>
  i18next
    .use(initReactI18next)
    .use(HttpBackend)
    .init<HttpBackendOptions>({
      lng: 'ru',
      fallbackLng: 'ru',
      ns: [
        'account',
        'actions',
        'auth-page',
        'auth-reset-password',
        'auth-sign-in',
        'auth-sign-up',
        'avatar',
        'bonded-page',
        'breadcrumbs',
        'cart-page',
        'cashback-status-constants',
        'checkout-page',
        'cloud-cart',
        'components',
        'confirmation-dialog-elements',
        'contractor-status-constants',
        'create-telegram-group-page',
        'dialogs',
        'distributor-info-modal',
        'distributor-settings',
        'dorim-finance-bank-application',
        'dorim-finance-page',
        'dorim-promo-bonus-chart',
        'drug-binding-page',
        'drug-info',
        'e-imzo-modal',
        'field-matching',
        'form-controls',
        'gallery',
        'license-holder-and-maker-info',
        'modal',
        'navbar',
        'nomenclature-page',
        'orders-page',
        'price-list-settings',
        'price-lists-page',
        'privacy-policy',
        'product-selection-alphabetical-index',
        'product-selection-auto',
        'product-selection-auto-binding-page',
        'product-selection-best-offers',
        'product-selection-bound-drugs',
        'product-selection-by-distributor',
        'product-selection-drug-list',
        'product-selection-filial-order',
        'product-selection-offers',
        'product-selection-page',
        'product-selection-settings',
        'product-selection-user-feedback-dialog',
        'product-update-page',
        'profile-page',
        'profile-popover',
        'referral-page',
        'referral-request-completed-page',
        'requirement-page',
        'requirements-calculation-page',
        'search-input',
        'settings',
        'settings-page',
        'sign-in',
        'specifications-analytics-page',
        'specifications-contract',
        'specifications-detail-page',
        'specifications-document-page',
        'specifications-main-contract',
        'specifications-marketing-org-page',
        'specifications-notice-page',
        'specifications-root-page',
        'status-constants',
        'support-menu-popover',
        'text-editor',
        'working-day-types-constants',
        'yup',
      ],

      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },

      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    });
